var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4256 24.8848C37.4256 26.2197 36.8953 27.4999 35.9514 28.4438C35.0075 29.3877 33.7273 29.918 32.3924 29.918C31.0575 29.918 29.7773 29.3877 28.8334 28.4438C27.8895 27.4999 27.3592 26.2197 27.3592 24.8848C27.3592 23.5499 27.8895 22.2697 28.8334 21.3258C29.7773 20.3818 31.0575 19.8516 32.3924 19.8516C33.7273 19.8516 35.0075 20.3818 35.9514 21.3258C36.8953 22.2697 37.4256 23.5499 37.4256 24.8848ZM21.3194 24.8848C21.3194 26.2197 20.7891 27.4999 19.8452 28.4438C18.9012 29.3877 17.621 29.918 16.2861 29.918C14.9512 29.918 13.671 29.3877 12.7271 28.4438C11.7832 27.4999 11.2529 26.2197 11.2529 24.8848C11.2529 23.5499 11.7832 22.2697 12.7271 21.3258C13.671 20.3818 14.9512 19.8516 16.2861 19.8516C17.621 19.8516 18.9012 20.3818 19.8452 21.3258C20.7891 22.2697 21.3194 23.5499 21.3194 24.8848Z",
    stroke: "white",
    strokeWidth: 1.81196
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2881 29.9219H32.3944",
    stroke: "white",
    strokeWidth: 1.81196,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20801 24.8867C4.20801 15.3961 4.20801 10.6508 7.15546 7.70135C10.1069 4.75391 14.8502 4.75391 24.3408 4.75391C33.8315 4.75391 38.5768 4.75391 41.5242 7.70135C44.4737 10.6528 44.4737 15.3961 44.4737 24.8867C44.4737 34.3774 44.4737 39.1227 41.5242 42.0701C38.5788 45.0196 33.8315 45.0196 24.3408 45.0196C14.8502 45.0196 10.1049 45.0196 7.15546 42.0701C4.20801 39.1247 4.20801 34.3774 4.20801 24.8867Z",
    stroke: "white",
    strokeWidth: 1.81196
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.76db78b3e9b2cee0393457d009492a57.svg";
export { ForwardRef as ReactComponent };